import Vue from 'vue'
import App from './App'
import VueResource from 'vue-resource'

import router from './sub/air_dark/router'
import { store } from './store/Works'
import { sync } from 'vuex-router-sync'

import i18n from './i18n'

/* eslint-disable no-new */

sync(store, router)
Vue.use(VueResource)
window.vue_router=router;//для видимости из глобальной области

var app = new Vue({
		el: '#app',
		router,
		store,
		i18n,
		template  : '<App/>',
		components : {App},
});
window.vue_app=app;//для видимости из глобальной области



//////////////////
// WEBPACK FOOTER
// ./src/main_sub_air_dark.js
// module id = null
// module chunks = 